import styled from "styled-components";

export const SearchContainer = styled.div`
  position: relative;
  margin-bottom: 16px;
  
  input {
    width: 100%;
    padding: 14px 16px 14px 44px;
    border: 2px solid #e2e8f0;
    border-radius: 12px;
    font-size: 14px;
    transition: all 0.2s;
    background: #f8fafc;
    box-sizing: border-box;
    
    &:focus {
      outline: none;
      border-color: #3b82f6;
      background: white;
      box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
    }
    
    &::placeholder {
      color: #94a3b8;
    }
  }
  
  .icon {
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: #94a3b8;
    font-size: 20px;
  }

  .clear-btn {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    color: #94a3b8;
    cursor: pointer;
    padding: 4px;
    display: flex;
    align-items: center;
    border-radius: 50%;
    
    &:hover {
      color: #64748b;
      background: #f1f5f9;
    }
  }
`;

export const Accordion = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const AreaCard = styled.div`
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  background: white;
`;

export const AreaHeader = styled.div<{ expanded: boolean; $isOrto?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  cursor: pointer;
  color: ${props => props.$isOrto ? '#fff' : 'inherit'};
  background: ${props => props.$isOrto
    ? 'linear-gradient(135deg, #6c3483 0%, #9b59b6 100%)'
    : props.expanded
      ? 'linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)'
      : '#f8fafc'};
  transition: all 0.2s;
  
  &:hover {
    background: ${props => props.$isOrto
      ? 'linear-gradient(135deg, #6c3483 0%, #9b59b6 100%)'
      : props.expanded
        ? 'linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)'
        : '#f1f5f9'};
  }
`;

export const AreaTitle = styled.div<{ $isOrto?: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  
  .icon {
    font-size: 18px;
    color: ${props => props.$isOrto ? '#fff' : '#3b82f6'};
  }
  
  span {
    font-size: 14px;
    font-weight: 600;
    color: ${props => props.$isOrto ? '#fff' : '#1e293b'};
  }
`;

export const AreaBadge = styled.span<{ $isOrto?: boolean }>`
  background: ${props => props.$isOrto
    ? 'rgba(255,255,255,0.3)'
    : 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)'};
  color: white;
  font-size: 11px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 12px;
`;

export const OrtoTag = styled.span`
  font-size: 10px;
  background: rgba(255,255,255,0.3);
  padding: 2px 8px;
  border-radius: 10px;
  margin-left: 5px;
  color: #fff;
`;

export const AreaContent = styled.div<{ expanded: boolean }>`
  display: ${props => props.expanded ? 'block' : 'none'};
  padding: 0;
`;

export const ProcItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-top: 1px solid #f1f5f9;
  transition: all 0.2s;
  
  &:hover {
    background: #fafafa;
  }
`;

export const ProcInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ProcNome = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: #1e293b;
  margin-bottom: 4px;
  line-height: 1.3;
`;

export const ProcMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const ProcValor = styled.span<{ showValue?: boolean }>`
  font-size: 13px;
  font-weight: 600;
  color: ${props => props.showValue ? '#10b981' : '#94a3b8'};
`;

export const ProcGrupos = styled.span`
  font-size: 11px;
  color: #64748b;
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const AddButton = styled.button<{ $blocked?: boolean }>`
  background: ${props => props.$blocked
    ? '#aaa'
    : 'linear-gradient(135deg, #10b981 0%, #059669 100%)'};
  border: none;
  color: white;
  padding: 8px 16px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 600;
  cursor: ${props => props.$blocked ? 'not-allowed' : 'pointer'};
  opacity: ${props => props.$blocked ? 0.45 : 1};
  transition: all 0.2s;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 4px;
  
  &:hover {
    ${props => !props.$blocked && `box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);`}
  }
  
  &:active {
    ${props => !props.$blocked && `transform: scale(0.95);`}
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  
  .spinner {
    width: 36px;
    height: 36px;
    border: 3px solid #e2e8f0;
    border-top-color: #3b82f6;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
    margin-bottom: 12px;
  }
  
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
  
  p {
    margin: 0;
    font-size: 14px;
    color: #64748b;
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #f59e0b;
  
  .icon {
    font-size: 32px;
    margin-bottom: 12px;
  }
  
  p {
    margin: 0;
    font-size: 14px;
    color: #64748b;
    text-align: center;
  }
`;

export const Stats = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  padding: 12px;
  background: #f8fafc;
  border-radius: 10px;
  margin-top: 16px;
  
  span {
    font-size: 12px;
    color: #64748b;
  }
`;

export const ExpandButtons = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
`;

export const ExpandButton = styled.button`
  padding: 8px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: white;
  font-size: 12px;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 6px;
  
  &:hover {
    border-color: #3b82f6;
    color: #3b82f6;
  }
`;

export const ChevronIcon = styled.span<{ expanded: boolean }>`
  display: flex;
  align-items: center;
  transition: transform 0.2s;
  transform: ${props => props.expanded ? 'rotate(180deg)' : 'rotate(0deg)'};
`;

